var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconModalPositive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 49.7812C14.4183 49.7812 4.21875 39.5817 4.21875 27C4.21875 14.4183 14.4183 4.21875 27 4.21875C39.5817 4.21875 49.7812 14.4183 49.7812 27C49.7812 39.5817 39.5817 49.7812 27 49.7812Z",
    fill: "#DBE7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3488 31.8133L35.7521 20.4101C36.4122 19.75 37.4824 19.75 38.1425 20.4101C38.8027 21.0703 38.8026 22.1407 38.1423 22.8008L25.3796 35.5581C24.8131 36.1244 23.8948 36.1241 23.3286 35.5575L16.9352 29.1594C16.2784 28.5022 16.2786 27.437 16.9356 26.78C17.5928 26.1228 18.6583 26.1228 19.3155 26.78L24.3488 31.8133Z",
    fill: "#053692"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconModalPositive);
export default __webpack_public_path__ + "static/media/icon_modal_positive.c34ecafc1cb30c212906803415e30386.svg";
export { ForwardRef as ReactComponent };